
import { useStore } from '@/hooks/useStore'
import { computed, defineComponent } from 'vue'

import {
  buildInfluenceGroups,
  buildInfluenceGroupsFromSnapshot,
} from './useInfluenceInfo'

export default defineComponent({
  name: 'MLayoutInfluenceTip',
  props: {
    isLessReverse: {
      type: Boolean,
      default: false,
    },
    isSpecialShape: {
      type: Boolean,
      default: false,
    },
    selectedPaibanWay: {
      type: String,
      default: '',
    },
    activePaibanWay: {
      type: Array as () => string[],
      default: () => [],
    },
    currentLine: {
      type: Object,
      default: null,
    },
    snapshot: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const store = useStore()

    const groups = computed(() => {
      if (props.snapshot) {
        return buildInfluenceGroupsFromSnapshot(props.snapshot)
      }

      return buildInfluenceGroups({
        ncSetting: store.state.ncSetting,
        preLayoutSetting: (store.state as any).preLayoutSetting,
        preferencesSetting: store.state.preferencesSetting,
        materialListStore: (store.state as any).materialListStore,
        paibanInfo: (store.state as any).paibanInfo,
        paibanData: (store.state as any).paibanData || [],
        isLessReverse: !!props.isLessReverse,
        isSpecialShape: !!props.isSpecialShape,
        isSurplusNoRoll: !!(store.state as any).isSurplusNoRoll,
        activePaibanWay: (props.activePaibanWay || []) as string[],
        selectedPaibanWay: props.selectedPaibanWay || '',
        currentLine: props.currentLine,
      })
    })

    const visibleGroups = computed(() => {
      return groups.value
        .map((g) => ({
          ...g,
          items: g.items.filter((it) => it.used),
        }))
        .filter((g) => g.items.length)
    })

    return {
      visibleGroups,
    }
  },
})
